import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { TextMarkdown } from "../../../../Shared/Components/TextMarkdown/TextMarkdown";
import { IWhiteLabelSegment } from "../WhiteLabelTab";

import "./WhiteLabelSegment.scss";

interface IWhiteLabelSegmentProps {
  segment: IWhiteLabelSegment;
}

export const WhiteLabelSegment: FunctionComponent<IWhiteLabelSegmentProps> = (props: IWhiteLabelSegmentProps) => {
  const { t } = useTranslation();

  return (
    <div className="white-label-segment">
      <h2>{t(props.segment.headerKey)}</h2>

      <div className="white-label-description">
        <TextMarkdown>{t(props.segment.descriptionMarkdownKey)}</TextMarkdown>
      </div>

      <div className="white-label-content">{props.segment.contentComponent}</div>
    </div>
  );
};
